import { Checkbox, FormGroup } from "@mui/material";
import { Box, FormControlLabel, Radio, RadioGroup } from "@mui/material";
import React, { useState } from "react";
import useBSSLogger from "../../../../hooks/useBSSLogger";
import __t from "../../../../lib/traduzioni";
import { BSSConfirmDialog} from "../../../form/BSSDialog";
const {logger} = useBSSLogger();


const DialogFiltroTipi = ({tipispedizione, filtri, setFiltri, dialogFiltroTipi, setDialogFiltroTipi}) => {

    const defFiltroTipi = tipispedizione.reduce((obj, t) => ({...obj, [Number(t.id)]: false}), {});

    const [filtroTipi, setFiltroTipi] = useState(defFiltroTipi);

    const aggiornaFiltriTipi = (value, checked) => {
        logger.debug(value, "selezionato: ", checked, filtroTipi);

        setFiltroTipi({...filtroTipi, [value]: checked})
    }

    const filtraTipi = (filtroTipi) => {

        const nuoviFiltri = {
            tipispedizione: Object
                .entries(filtroTipi)
                .filter(([id, checked]) => checked)
                .reduce((arr, [id]) => [
                    ...arr,
                    Number(id)
                ], [])
        }

        setFiltri({
            ...filtri, 
            filtriRicerca: {
                ...filtri.filtriRicerca,
                ...nuoviFiltri
            }, 
            skip: 0
        });
        setFiltroTipi(defFiltroTipi)
        setDialogFiltroTipi({mostra: false})
    }

    return (
        <BSSConfirmDialog
            title={__t("mostrapertiposped")}                                                        
            open={dialogFiltroTipi.mostra} 
            undoAction={e => setDialogFiltroTipi({mostra: false})} 
            confirmAction={e => {
                filtraTipi(filtroTipi)
            }}
            sx={{"& .MuiDialogContent-root": {p: 0}}}
        >
            <Box p={2}>
                {/* <pre>{JSON.stringify(tipispedizione, null, 2)}</pre> */}
                <FormGroup                   
                >
                    {tipispedizione.map((t) => {
                        return (
                            <FormControlLabel 
                                onChange={e => {
                                    aggiornaFiltriTipi(e.target.value, e.target.checked)
                                }}
                                key={t.id} 
                                value={t.id} 
                                checked={filtroTipi[t.id]}
                                control={<Checkbox />} 
                                label={t.descrizione} 
                            />
                        )
                    })}
                </FormGroup>
                
            </Box>

        </BSSConfirmDialog>
    )
}

export default DialogFiltroTipi;